<app-kontable title = "{{ 'countryList.sectionTitle' | translate }}"
              [columns] = "['id', 'iso_code', 'name', 'language', 'currency']"
              [titles] = "['common.id', 'common.isoCode', 'common.name', 'common.language', 'common.currency']"
              [showInfoButton]="true"
              [showRecoverButton]="true"
              [showGlobalFilter]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [service]="srvCountry"
              [paginationType]="paginationType"
              [(fireNewDataAvailable)]="newDataAvailable"
              (onAdd)="showEditDialog($event)"
              (onEdit)="showEditDialog($event)"
              (onRemove)="removeCountry($event)"
              (onRecover)="recoverCountry($event)"
              (includeDeletedChange)="includeDeletedChange($event)">
</app-kontable>

<p-dialog *ngIf="showDetail"
          [width]="600"
          [(visible)]="showDetail"
          header="{{modalTitle}}"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          (onHide)="onDialogHide()">

  <app-kv-country-form
                  [dialogBoxCountry]="selectedCountry"
                  (countryAdded)="countryAdded($event)"
                  (countryUpdated)="countryUpdated($event)">
  </app-kv-country-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/country/country.component.html